import React from 'react';

const MenuList = () => {
    return (
        <svg width={2.794} height={12.575} viewBox="0 0 2.794 12.575">
            <circle cx={1.397} cy={1.397} r={1.397} fill="#0d1fa1" />
            <circle
                cx={1.397}
                cy={1.397}
                r={1.397}
                transform="translate(0 4.89)"
                fill="#0d1fa1"
            />
            <circle
                cx={1.397}
                cy={1.397}
                r={1.397}
                transform="translate(0 9.78)"
                fill="#0d1fa1"
            />
        </svg>
    );
};

export default MenuList;
